
import Container from '@material-ui/core/Container';
import ClientSignature from '../../assets/images/client-signature.png';


const months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const ConfidentTermsText = ({ clientData, today }) => {
    const getCountryName = (code) => {
        try {
            return new Intl.DisplayNames(['es'], {type: 'region'}).of(code)
        } catch {
            return code
        }
    };

    return (
        <Container>
            <span className="text-2 text-black">
                En Santiago, a {today.getDate()} de {months[today.getMonth()]} de {today.getFullYear()}, {clientData.company_real_name}{' '}
                en adelante también denominada la “Empresa”, por una parte; y, por la otra, TEAMCORE SOLUTIONS SPA, RUT 76.350.854-4,
                debidamente representada por doña Nubia Galindo, colombiana, pasaporte CC 52087578 , ambos domiciliados para estos
                efectos en Av. Badajoz 55, Las Condes, Santiago, en adelante también “TEAMCORE” o el “Prestador”, ambas partes en
                conjunto en adelante las “Partes” y cada una como la “Parte”, quienes han acordado el siguiente Acuerdo de Confidencialidad,
                en adelante el “Acuerdo”:
            </span>
            <br />
            <br />
            <h4 className="title-4 text-black">PRIMERO: ANTECEDENTES</h4>
            <span className="text-2 text-black">
                1.1.&emsp;TEAMCORE, es una empresa que trabaja con IA y Machine Learning para detectar oportunidades de ejecución, permitiendo mejorar
                la disponibilidad de productos online en la página web y/o en góndola de la tienda física donde se preparan los pedidos. 
                <br />
                <br />

                1.2.&emsp;Con el objeto de utilizar los productos de TEAMCORE, por una Parte, y de prestar sus servicios por la otra, las Partes expresan
                el interés mutuo en intercambiar informaciones relativas a: Información general y específica de ventas, inventarios, quiebres de
                stock e información derivada de la actividad comercial de la Empresa. Por lo tanto, las Partes dispondrán de los datos e información
                que se hagan necesaria, siempre y cuando la utilización de esta sea para fines específicos y restringidos a los negocios de su propio
                interés y con miras a la celebración de un posible contrato de prestación de servicios entre las Partes.
                <br />
                <br />

                1.3.&emsp;Las Partes entienden y reconocen que, con relación a los datos y a las informaciones proporcionadas por ambas Partes,
                deben mantenerse el más absoluto secreto y confidencialidad.
                <br />
                <br />

                1.4.&emsp;Las Partes declaran que no existe ningún impedimento para la celebración de este Acuerdo y deciden firmarlo,
                de acuerdo con los términos de las clausulas y disposiciones que siguen:
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">SEGUNDO: INFORMACIÓN CONFIDENCIAL Y PROPIEDAD INTELECTUAL</h4>
            <span className="text-2 text-black">
                2.1.&emsp;Se entenderá por “Información Confidencial”, toda información sobre, relativa a, o de propiedad de la Empresa o del Prestador,
                de sus sociedades relacionadas o de cualquiera de las personas o empresas controladoras de, controladas por, o bajo un control común
                con la Empresa o el Prestador, respectivamente, en cualquier soporte o formato en que la misma se comunique o registre, tangible o intangible,
                sea transitoria o permanentemente, que la Empresa ponga a disposición de TEAMCORE o el Prestador ponga a disposición de la Empresa,
                con ocasión del presente Acuerdo. También incluye la información a la que acceda la Empresa o TEAMCORE, mediante inspección visual,
                o que por cualquier otro medio llegue a conocimiento, posesión o tenencia de cualquiera de ellas, con motivo u ocasión de este Acuerdo,
                incluyendo, pero sin limitarse a: 
                <br />
                <br />

                <div className="ml-4">
                    <ol type="i">
                        <li>
                            Bases de datos y en general datos de clientes de la Empresa, TEAMCORE y de sus clientes;
                        </li>

                        <li>
                            Operaciones, planes, modelos, estudios, documentos, análisis, encuestas, informes, políticas, registros, actividades, estrategias,
                            técnicas, datos, conceptos, mecanismos, información estadística, proyecciones y procedimientos operativos, financieros, de comercialización o de
                            cobranza, marca, propiedad industrial, propiedad intelectual, aspectos relacionados con la estrategia de negocios y planes futuros en el área
                            de marcas propias, publicidad, promoción, propaganda, suministro, crecimiento, posicionamiento de mercado, aprovechamiento de mercado,
                            participación de mercado, desarrollo, tecnología, softwares, archivos electrónicos magnéticos, recursos humanos, aprovisionamiento,
                            datos personales, comerciales o financieros de clientes actuales o potenciales, y antecedentes respecto a créditos y negocios;
                        </li>

                       <li>
                            Bases de datos de proveedores de las Partes con sus nombres, rol único tributario, domicilios y demás datos personales,
                            documentos de pago o cobro que cada Parte tiene con cada proveedor (facturas, notas de crédito, notas de débito), condiciones y
                            plazo de pago a proveedores; sistemas informáticos, de contabilidad, financieros y de tesorería relacionados con el pago a proveedores.
                        </li>

                        <li>
                            Contratos, acuerdos, pactos, convenios, convenciones, arreglos contractuales y demás actos jurídicos unilaterales,
                            bilaterales o plurilaterales, e información sobre, o relativa a, la parte de dichos contratos, acuerdos, pactos, convenios, convenciones,
                            arreglos contractuales o actos jurídicos en los que alguna Parte, y/o sus filiales sean parte directa o indirecta o tenga interés de cualquier naturaleza;
                        </li>

                        <li>
                            Derechos y privilegios de propiedad intelectual o industrial, registrados o no, de cualquier especie;
                        </li>

                        <li>
                            Secretos comerciales, industriales o económicos, precios de productos y servicios, procesos, procedimientos, conocimiento especializado (know-how),
                            modelos, derechos de autor, programas de software, documentación y programas fuente, técnicas y estrategias de negocio, análisis de mercados,
                            las propuestas y planes de mercadotecnia, información financiera, necesidades internas, análisis, recopilaciones, estudios y otros documentos preparados por TEAMCORE,
                            o sus representantes que contengan o reflejen la información anterior o su revisión; y,
                        </li>

                        <li>
                            Toda la información que se genere del o con ocasión del servicio que presta TEAMCORE,
                            ea en original o sus copias de respaldo, cualquiera sea su soporte o formato.
                        </li>
                    </ol>
                </div>
                <br />

                2.2.&emsp;Las Partes dejan constancia que toda la Información Confidencial deberá ser considerada como de exclusiva propiedad de la “Parte Divulgadora”,
                entendiéndose por tal para efectos de este Acuerdo aquella que haya revelado la Información Confidencial de que se trate a la otra, no pudiendo
                la otra Parte utilizarla para efecto alguno salvo el de este Acuerdo.
                <br />
                <br />

                2.3.&emsp;El contenido de este Acuerdo se considera también Información Confidencial.
                <br />
                <br />

                2.4.&emsp;El presente Acuerdo no prohíbe a las Partes negociar y llegar a acuerdos con terceros, en cualquier área de negocios, mientras no se
                divulgue Información Confidencial entregada por la otra Parte, en los términos expuestos en el presente Acuerdo.
                <br />
                <br />

                2.5.&emsp;Las Partes reconocen expresamente que el único titular de la propiedad industrial e intelectual, incluyendo de forma enunciativa mas no limitativa,
                sus respectivos derechos de autor, marcas, nombres comerciales, diseños industriales, avisos comerciales, etc., incluyendo los derechos patrimoniales y
                el prestigio asociado con las mismas, es de cada una de ellas, obligándose expresamente a no ejercitar sin autorización, acción alguna concerniente al uso,
                propiedad o divulgación de la mencionada propiedad industrial o intelectual.
                <br />
                <br />

                Se deja expresa constancia que el software y todos los servicios objeto de este Acuerdo de Confidencialidad se desarrollan bajo el formato “SaaS”
                (software como un servicio según su acrónimo en inglés), a través de softwares de propiedad del Prestador, tales como INSTOREVIEW, SMART OSA, SMART RETAIL EXECUTION y
                otros, y de KPIs desarrollados también por el Prestador (en adelante, todos los mencionados softwares y KPIs en conjunto denominados como los “Productos Teamcore”,
                los que comprenden entre otros el software). De esta manera, el Prestador conservará todos los derechos de propiedad intelectual, industrial o cualesquiera otros sobre
                los Productos Teamcore, los cuales no podrán ser objeto de ulterior modificación, copia, alteración, reproducción, adaptación o traducción por parte de la Empresa o
                cualquier entidad relacionada a ésta. A mayor abundamiento, la estructura, características, códigos, algoritmos, métodos de trabajo, sistemas de información,
                herramientas de desarrollo, know-how, metodologías, procesos, tecnologías, manuales de uso, textos y dibujos gráficos utilizados para la prestación de los servicios
                son propiedad del Prestador, y no pueden ser objeto de modificación, copia, alteración, reproducción, adaptación o traducción por parte de la Empresa o cualquier entidad
                relacionada a éste. En consecuencia, el acceso que se otorga a la Empresa en relación con los Productos Teamcore se extiende exclusivamente para el objeto de este Acuerdo,
                y en ningún caso implican la cesión de la titularidad de los mismos, ni la concesión de algún derecho de uso distinto de los previstos en este contrato. Además,
                queda terminantemente prohibido cualquier uso de los Productos Teamcore que se realice sin la autorización expresa del Prestador, incluida su explotación, reproducción,
                difusión, transformación, distribución, transmisión por cualquier medio, posterior publicación, exhibición, comunicación pública o representación total o parcial,
                las cuales, de producirse, constituirán infracciones de los derechos de propiedad intelectual o industrial del Prestador. Finalmente, se deja constancia que cualquier
                modificación, mejora, nuevo desarrollo, complemento o adaptación a los Productos Teamcore que se genere como consecuencia de este Acuerdo será de propiedad exclusiva del Prestador,
                quien podrá obtener a su favor las patentes y o registros pertinentes si lo estimare necesario.
                <br />
                <br />

                Las Partes aceptan que el incumplimiento de las obligaciones consignadas en los párrafos anteriores dará derecho a la parte afectada para ejercitar las acciones civiles o
                penales que le correspondan por violación a los derechos de propiedad intelectual e industrial de la otra Parte.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">TERCERO: OBJETO Y OBLIGACIONES DE LAS PARTES</h4>
            <span className="text-2 text-black">
                3.1.&emsp;El objeto de este Acuerdo es establecer el secreto y la confidencialidad con relación a la Información Confidencial, proporcionada por las Partes entre si en el
                proceso de intercambio de información mencionado precedentemente con miras a determinar la concreción o no de una relación contractual a futuro.
                <br />
                <br />

                3.2.&emsp;Las Partes se obligan a:
                <br />
                <br />

                <div className="ml-4">
                    <ol type="i">
                        <li>
                            Usar la Información Confidencial única y exclusivamente para los efectos de cumplir en forma adecuada con las gestiones convenidas en este Acuerdo;
                        </li>

                        <li>
                            Mantener en estricta reserva y manejar confidencialmente respecto de cualquier persona natural o jurídica, la Información Confidencial a que acceda;
                        </li>

                        <li>
                            Custodiar y proteger diligentemente toda la Información Confidencial a que tenga acceso, conocimiento o que se encuentre en su poder y custodiar y
                            proteger diligentemente, asimismo, todos y cada uno de los soportes, de cualquier especie o formato, en los que conste o se contenga parte alguna de la Información Confidencial; 
                        </li>

                        <li>
                            Dar y permitir acceso o conocimiento a la Información Confidencial única y exclusivamente a aquellos de sus empleados, cualquiera sea el vínculo que los una,
                            que se desempeñen laboralmente en cargos de confianza, de modo limitado a lo que fuere necesario que dichos empleados deban conocer sobre tal Información Confidencial,
                            tal y como si se tratara de Información Confidencial propia;
                        </li>

                        <li>
                            Imponer sobre aquellos de sus empleados, cualquiera sea el vínculo que los una, que tengan acceso a la Información Confidencial, obligaciones y restricciones de uso y
                            divulgación de dicha información idénticas a las que se le imponen por el presente instrumento, imposición que efectuará por los medios que estime conveniente;
                        </li>

                        <li>
                            Responder por el hecho o culpa de sus empleados, cualquiera sea el vínculo que los una, que infringieren las obligaciones de confidencialidad establecidas en este instrumento; 
                        </li>

                        <li>
                            Abstenerse de hacer copias o reproducciones de la Información Confidencial que no sean estrictamente necesarias para los efectos del presente Acuerdo;
                        </li>

                        <li>
                            No impugnar ni pretender titularidad o autoría de ninguna especie sobre la Información Confidencial, especialmente sobre los Productos Teamcore que son de exclusiva propiedad de TEAMCORE;
                        </li>

                        <li>
                            No solicitar privilegio de propiedad intelectual o industrial alguna relativo a la Información Confidencial;
                        </li>

                        <li>
                            Comunicar inmediatamente y por escrito a la otra Parte, acerca de la ocurrencia de cualquier acto, hecho u omisión que constituya una infracción a las
                            obligaciones asumidas precedentemente, sea por acciones u omisiones propias, de sus dependientes o de terceros; e,
                        </li>

                        <li>
                            Impetrar todas las medidas que fueren necesarias o convenientes y cooperar para que, en el evento que, por acto, hecho u omisión suya o de sus empleados o dependientes,
                            todo o parte de la Información Confidencial hubiere sido divulgada en contravención a lo establecido en este instrumento.
                        </li>
                    </ol>
                </div>
                <br />

                Sin perjuicio de lo anterior, el Prestador estará facultado en todo momento para contratar servicios tecnológicos con terceros que sean necesarios para la adecuada ejecución del Acuerdo,
                debiendo al efecto estipular con dichos terceros cláusulas de confidencialidad en el manejo de la información que cumplan con los estándares de este Acuerdo al respecto,
                lo anterior sin perjuicio de mantener informada a la Empresa sobre cualquier subrogación, subcontratación o tercerización de los servicios.
                <br />
                <br />

                3.3.&emsp;Ninguna de las Partes empleará el nombre de la otra o el de sus sociedades relacionadas para obtener beneficios personales que sean o puedan ser directos o indirectos.
                El incumplimiento de esta obligación hará responsable a la Parte infractora por los perjuicios que cause directamente a la otra Parte o a sus sociedades relacionadas sin que ello
                impida la iniciación de las acciones penales correspondientes.
                <br />
                <br />

                3.4.&emsp;Los empleados, dependientes, profesionales, contratistas o subcontratistas de las Partes, deberán cumplir las disposiciones de la Ley N°17.336, sobre Propiedad Intelectual,
                de la Ley N°19.628 sobre Protección de Datos de Carácter Personal, y no infringir la Ley N°19.223 artículos 1, 2, 3 y 4, sobe Delitos Informáticos; normas todas las cuales protegen
                la información contenida en sistemas de información, bases de datos, archivos electrónicos magnéticos y todas las normas legales existentes o que se dicten en el futuro que consagren
                obligaciones de confidencialidad y secreto en la actividad comercial e industrial.
                <br />
                <br />

                3.5.&emsp;En el evento que alguna de las Partes o sus representantes o cualquier persona a quienes la Parte Divulgadora le entregue Información Confidencial, en conformidad a
                este Acuerdo llegase a estar legalmente obligada o es requerida para revelar la información, la Parte o sus representantes o dicha persona, deberán previamente enviar una comunicación
                escrita a la otra Parte, para que ésta, si lo estima pertinente, procure la obtención de alguna medida de protección o prohibición o cualquier otra medida adecuada o renuncie a
                exigir el cumplimiento de las disposiciones de este Acuerdo. En este caso, la Parte obligada a revelar información se comprometerá en dar a conocer solamente lo que legalmente este
                obligado a entregar y realizará sus mejores esfuerzos para obtener tratamiento confidencial para la Información Confidencial revelada, manteniendo a la otra Parte debidamente informada del contenido entregado.
                <br />
                <br />

                3.6.&emsp;No constituirán infracción a este instrumento los actos, hechos u omisiones relativos a la Información Confidencial que vulneren lo establecido precedentemente,
                si: i) la información del caso es de acceso o conocimiento público previo al momento en que le fue comunicada a una de las Partes; ii) sin mediar acto, hecho u omisión de una de las Partes,
                la Información Confidencial de la otra Parte, y/o de sus filiales se convierte en información generalmente disponible para el público; y; iii) la divulgación del caso se hace por una
                de las Partes, en cumplimiento de una obligación legal o de una orden no impugnable emanada de una autoridad competente con facultades para requerir la información del caso,
                debiendo en todo caso proceder en la forma indicada precedentemente.
                <br />
                <br />

                3.7.&emsp;La obligación de confidencialidad de la Parte a quien se le ha divulgado ésta, de sus sucesores legales, de sus empleados,
                dependientes o asesores externos deberá mantenerse por el plazo de 3 años después de terminado este instrumento. 
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">CUARTO: DESTRUCCIÓN O DEVOLUCION DE INFORMACION CONFIDENCIAL</h4>
            <span className="text-2 text-black">
                Al sólo requerimiento de la Parte Divulgadora, la otra Parte deberá destruir toda la Información Confidencial tangible de la Parte Divulgadora que estuviese en su poder, en cualquier formato
                o soporte que dicha Información Confidencial se contenga, sea en original o en copia, hayan sido dichas copias elaboradas por la Parte que recibió la información o por aquellas personas que hayan
                tenido acceso a, o conocimiento, posesión o tenencia de la misma, debiendo notificar por escrito a la Parte Divulgadora de tal destrucción, esto sin perjuicio del derecho de la Parte Divulgadora
                de estar presente en tal proceso. Alternativamente, la Parte Divulgadora podrá requerir a la otra que, dentro del plazo máximo de 5 días hábiles, restituya toda o parte de la información recopilada
                y/o recibida con ocasión del presente Acuerdo de Confidencialidad, cualquiera sea el soporte en que ella esté consignada y/o almacenada.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">QUINTO: NATURALEZA DEL ACUERDO</h4>
            <span className="text-2 text-black">
                5.1.&emsp;Las Partes dejan constancia de que ni entre TEAMCORE y la Empresa, ni entre TEAMCORE, y los empleados, dependientes, contratistas, subcontratistas o los empleados o dependientes
                de los contratistas o subcontratistas de la Empresa, ni entre la Empresa y los empleados, dependientes, contratistas, subcontratistas o los empleados o dependientes de los contratistas o
                subcontratistas de Prestador, existe o existirá relación o vínculo laboral alguno.
                <br />
                <br />

                5.2.&emsp;Como consecuencia de lo expresado anteriormente, cada una las Partes será sola y únicamente responsable por: a) las prestaciones laborales, de seguridad social y tributarias de sus
                respectivos empleados o dependientes, tales como, entre otras, remuneraciones, sueldos, asignaciones, viáticos, vacaciones, alimentación, indemnizaciones sustitutivas de aviso previo de despido,
                indemnizaciones por despido, cotizaciones de salud, cotizaciones previsionales, descuentos por impuestos, cotizaciones por previsión de accidentes laborales y enfermedades profesionales; y,
                b) las responsabilidades que puedan corresponderles por hechos o eventos, realizados por o que afecten a, sus respectivos empleados o dependientes, tales como, entre otros, lesiones, accidentes
                del trabajo, enfermedades profesionales o daños, a los dichos empleados o dependientes o a terceros; todo lo anterior, esto es, lo establecido en los numerales a) y b) precedentes, en aplicación
                de las normas vigentes en materia de derecho laboral, de la seguridad social y responsabilidad civil por hechos de terceros.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">SEXTO: VIGENCIA</h4>
            <span className="text-2 text-black">
                6.1.&emsp;El presente instrumento estará vigente desde la fecha de suscripción del Acuerdo con fecha indefinida y también posterior a la finalización de la relación comercial.
                <br />
                <br />

                6.2.&emsp;Las Partes acuerdan que el presente instrumento tiene una duración de 1 año desde terminada la relación comercial entre ambas partes.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">SÉPTIMO: LEGISLACIÓN APLICABLE Y JURISDICCIÓN</h4>
            <span className="text-2 text-black">
                7.1.&emsp;Este Acuerdo se regirá y será interpretado acorde a las leyes de la República de Chile.
                <br />
                <br />

                7.2.&emsp;Para todos los efectos legales y los actos judiciales y extrajudiciales que diere lugar el presente contrato, las partes acuerdan someterse a la jurisdicción de los
                Tribunales Ordinarios de Justicia de la ciudad de Santiago de Chile.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">OCTAVO: NORMATIVA ANTICORRUPCIÓN LEY 20.393</h4>
            <span className="text-2 text-black">
                8.1.&emsp;<u>Cumplimiento de la Ley y la Política</u>. TEAMCORE y la Empresa, acuerdan que el cumplimiento de sus obligaciones en virtud de este Acuerdo se ajustará estrictamente
                a la Política y todas las leyes y normativa anticorrupción aplicables, lo que incluye sin carácter limitativo la Ley 20.393 que establece la responsabilidad penal de las personas
                jurídicas. En consecuencia, las Partes acuerdan en relación con sus actividades en virtud de este Acuerdo, que ni TEAMCORE, ni la Empresa ni ninguno de sus mandatarios, afiliados,
                empleados u otras personas que actúen en su nombre ofrecerán, prometerán, entregarán o autorizarán la entrega de un objeto de valor ni ofrecerán, prometerán, entregarán o autorizarán
                la entrega de sobornos, descuentos, retribuciones, pagos de influencia, pagos de facilitación, comisiones ilegales u otros pagos ilegales a un Funcionario Público, partido político
                o candidato a un cargo público a fin de obtener o conservar un negocio, obtener una ventaja indebida, o influir en los actos o decisiones de un Funcionario Público.
                <br />
                <br />

                8.2.&emsp;<u>Prohibición de Gestión</u>. En ninguna circunstancia una Parte, sus socios, directores, accionistas, contratistas, subcontratistas, empleados o gestores,
                podrá representar directa o indirectamente a la otra Parte ante entidades públicas, autoridades gubernamentales o funcionarios públicos. Tampoco tendrá autorización para negociar directamente
                o indirectamente en representación de la otra Parte, ni para su beneficio ante entidades públicas, autoridades gubernamentales o funcionarios públicos.
                <br />
                <br />

                8.3.&emsp;<u>Cooperación con Investigaciones</u>. Las Partes acuerdan proveer asistencia y cooperación en las investigaciones de posibles violaciones de la Política o las leyes y normativa anticorrupción.
                <br />
                <br />

                8.4.&emsp;<u>Derecho de Término del Acuerdo</u>. En caso de que la un Parte determinara, a su entero criterio, que la otra Parte ha participado en una conducta que viola la Política o
                las leyes y normativa para prevenir corrupción, cohecho, lavado de dinero, o financiamiento de terrorismo, la Parte tendrá inmediatamente derecho terminar el Acuerdo sin necesidad de
                declaración judicial o expresión de causa.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">NOVENO: DISPOSICIONES GENERALES</h4>
            <span className="text-2 text-black">
                9.1.&emsp;Las Partes establecen que la posible invalidez o inejecutabilidad de cualquier disposición de este documento, no afectará las demás, haciendo que estas continúen válidas y eficaces.
                <br />
                <br />

                9.2.&emsp;Ninguna de las Partes entregará, transferirá o cederá los derechos u obligaciones de este documento a un tercero sin previa aprobación por escrito de la otra Parte.
                <br />
                <br />

                9.3.&emsp;Cualquier concesión o tolerancia por el no cumplimento de cualquier obligación relacionada a este instrumento, por una de las Partes, se considera una mera liberalidad
                de la parte que la permite, no constituyendo una novación, precedente, modificación implícita de sus términos, renuncia de derechos como asimismo tampoco será entendido como un derecho adquirido por la otra parte.
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">DECIMO: COMUNICACIONES</h4>
            <span className="text-2 text-black">
                Toda comunicación que deban efectuar entre sí las Partes de conformidad con el presente Acuerdo deberá realizarse por vía correo electrónico, Las comunicaciones deberán ser enviadas
                a los siguientes representantes de las partes, o a los que los sucedan y sean informados por las partes oportunamente:
                <br />
                <br />

                A TEAMCORE:
                <br />
                1. Atención: Nubia Galindo
                <br />
                2. Domicilio: Av. Badajoz 55, Las Condes
                <br />
                3. Email: nubia.galindo@teamcore.net
                <br />
                4. Teléfono: +57 316 8767844
                <br />
                5. Con Copia a: administracion@teamcore.net
                <br />
            </span>

            <br />
            <h4 className="title-4 text-black">PERSONERIAS</h4>
            <span className="text-2 text-black">
                La personería de doña Nubia Galindo para representar a TEAMCORE SOLUTIONS SpA consta de escritura pública otorgada el 29 de agosto de 2022 en la notaría de Santiago de don Álvaro Gonzalez Salinas.
                <br />
                <br />

                El presente Acuerdo se suscribe forma electrónica.
                <br />
            </span>

            <br />
            <br />
            <div className="row">
                <div className="col-sm-3 offset-sm-2 col-xs-12" style={{ marginTop: '25px' }}>
                    <div className="row d-flex justify-content-center">
                        <img src={ClientSignature} alt="signature" style={{ width: '150px' }} />
                    </div>
                    <br />
                    <div className="row d-flex justify-content-center">
                        <span className="text">
                            <b style={{ color: '#000' }}>____________________________________</b><br/>
                        </span>
                        <br />
                    </div>
                    <div className="row d-flex justify-content-center">
                        <span className="text-2 text-blue" style={{ width: '195px', height: '14px' }}>
                            <b>{clientData.company_real_name}</b><br/>
                            <b>REPRESENTANTE LEGAL</b>
                        </span>
                    </div>
                </div>
                <div className="col-sm-3 offset-sm-2 col-xs-12" style={{ marginTop: '25px' }}>
                    <div className="row d-flex justify-content-center">
                        <img src={ClientSignature} alt="signature" style={{ width: '150px' }} />
                    </div>
                    <br />
                    <div className="row d-flex justify-content-center">
                        <span className="text">
                            <b style={{ color: '#000' }}>____________________________________</b><br/>
                        </span>
                        <br />
                    </div>
                    <div className="row d-flex justify-content-center">
                        <span className="text-2 text-blue" style={{ width: '195px', height: '14px' }}>
                            <b>Nubia Galindo</b><br/>
                            <b>TEAMCORE SOLUTIONS SPA</b>
                        </span>
                    </div>
                </div>
            </div>
            <br/>
            <br/>
            <br/>
            <br/>
        </Container>
    )
};

export default ConfidentTermsText;
